import { Component, ViewChild } from '@angular/core';
import { defaultPedidoCompraPainelAprovacao, PedidoCompraPainelAprovacaoItem } from './interface/interface';
import { FiltroListaPedidoCompraPainelAprovacao } from './filter/filtro';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDisclaimerGroupComponent, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoTableColumn } from '@po-ui/ng-components';
import { Fornecedor } from 'src/app/interface/fornecedor';
import { PoStorageService } from '@po-ui/ng-storage';
import { Router } from '@angular/router';
import { ExcelService } from 'src/app/service/excel-service';
import { PedidoCompraService } from '../pedido-compra/service/pedido-compra.service';
import { CentroCustoLookupService } from 'src/app/service/centro-custo-lookup-service';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';

@Component({
  selector: 'app-painel-aprovacao-pedido-compra',
  templateUrl: './painel-aprovacao-pedido-compra.component.html',
  styleUrl: './painel-aprovacao-pedido-compra.component.css'
})
export class PainelAprovacaoPedidoCompraComponent {

  tabelaPrincipalItens: Array<PedidoCompraPainelAprovacaoItem> = [];
  tabelaPrincipalExcel: Array<PedidoCompraPainelAprovacaoItem> = [];
  tabelaPrincipalItensFiltrado: Array<PedidoCompraPainelAprovacaoItem> = [];
  tabelaPrincipalFiltro: FiltroListaPedidoCompraPainelAprovacao;
  tabelaPrincipalDetalhes: Array<PedidoCompraPainelAprovacaoItem> = [];
  formatBasic: PoDatepickerIsoFormat;
  fornecedorAdvancedFilters: Array<PoDynamicFormField>;
  fornecedorColumnsFilters: Array<PoLookupColumn>;
  fornecedorFieldFormaterFilters: (value: Fornecedor) => string;
  centroCustoColumnsFilters: Array<PoLookupColumn> = this.centroCustoLookupService.getColumnsFilter();
  //@ts-ignore
  disclaimerGroup;
  private disclaimers = [];

  @ViewChild('filtroAvancadoModal',{static:true}) filtroAvancadoModal !: PoModalComponent;

  constructor(
    private poStorageService: PoStorageService,
    private router: Router,
    private poNotificationService: PoNotificationService,
    private excelService: ExcelService,
    public pedidoCompraService: PedidoCompraService,
    public centroCustoLookupService: CentroCustoLookupService,
    public fornecedorLookupService: FornecedorLookupService
  ){
    this.tabelaPrincipalFiltro = new FiltroListaPedidoCompraPainelAprovacao(poStorageService, 'compras-pedido-compra-lista-painel-aprovacao');
    this.formatBasic = PoDatepickerIsoFormat.Basic
    this.fornecedorAdvancedFilters = this.fornecedorLookupService.getAdvancedFilter();
    this.fornecedorColumnsFilters = this.fornecedorLookupService.getColumnsFilter();
    this.fornecedorFieldFormaterFilters = this.fornecedorLookupService.getFieldFormater;
    this.disclaimerGroup = {
      title: 'Filtros',
      disclaimers: [],
      change: this.onChangeDisclaimer.bind(this)
    }
  }

  ngOnInit(): void{
    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void{
    this.tabelaPrincipalFiltro.setStorage();
    if (!this.tabelaPrincipalFiltro.dados.DC7EMISSAO_DE || !this.tabelaPrincipalFiltro.dados.DC7EMISSAO_ATE )  {
      this.poNotificationService.warning({
        message: 'Informe o periodo nos filtros',
        duration: 5000,
      })
    } else {
      this.tabelaPrincipalFiltro.dados.page = 1;
      this.tabelaPrincipalItens = [];
      this.tabelaPrincipalItensFiltrado = [];

      this.pedidoCompraService.getPainelAprovacao(this.tabelaPrincipalFiltro.dados).subscribe(ret => {
        ret.items = ret.items.map(item => {
          return { ...item, detalehs: [defaultPedidoCompraPainelAprovacao()]};
        });
        this.tabelaPrincipalItens = this.tabelaPrincipalItens.concat(ret.items);
        this.tabelaPrincipalItensFiltrado = this.tabelaPrincipalItens;
        this.resetFilterTabelaPrincipal();
      })
    }
  }

  showDetalhes():boolean{
    return true;
  }

  exportaExcel(): void{
    
    this.pedidoCompraService.getPainelAprovacao(this.tabelaPrincipalFiltro.dados).subscribe(ret => {
      ret.items = ret.items.map(item => {
        return { ...item,detalhes: [defaultPedidoCompraPainelAprovacao()]};
      });
      this.tabelaPrincipalExcel = ret.items
      const lista_excel = this.tabelaPrincipalExcel.map((item: PedidoCompraPainelAprovacaoItem)=>{
        return{
          'Status'           : item.CCRSTATUS,
          'Emissao'          : item.DC7EMISSAO,
          'Pedido'           : item.CCRNUM,
          'Codigo'           : item.CC7FORNECE,
          'Fornecedor'       : item.CA2NREDUZ,
          'Cod.CC'           : item.CC7CC,
          'Centro Custo'     : item.CCTTDESC01,
          'Valor Pedido'     : item.NCRTOTAL,
          'Nivel'            : item.CCRNIVEL,
          'Valor LIberado'   : item.NCRVALLIB,
          'Data Lib'         : item.DCRDATALIB,
          'Aprovador'        : item.CCRUSERLIB,
          'Obs'              : item.CCROBS,
          'Lista Aprovadores': item.CCRUSER
        }
      })
      this.tabelaPrincipalExcel = [];
      this.excelService.exportAsExcelFile(lista_excel,'Painel_Aprovacao')
    })
  }

  public readonly breadcrumb : PoBreadcrumb = {
    items: [
      { label: 'Compras', action: this.goTo.bind(this)},
      { label: 'Painel de Aprovacao'}
    ]
  };
  goTo(): void {
    this.router.navigateByUrl('');
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    { property: 'CCRSTATUS', label: 'Status', width: '8%', visible: true, type: 'label',
      labels: [
        { value: 'Aprovado'           , label: 'Aprovado'           , color: 'color-10'},
        { value: 'Pendente'           , label: 'Pendente'           , color: 'color-07'},
        { value: 'Bloqueado'          , label: 'Bloqueado'          , color: 'color-07'},
        { value: 'Aprovado/Rejeitado' , label: 'Aprovado/Rejeitado' , color: 'color-07'},
        { value: 'Rejeitado'          , label: 'Rejeitado'          , color: 'color-07'},
        { value: 'Rejeitado/Bloqueado', label: 'Rejeitado/Bloqueado', color: 'color-07'},
      ]
    },
    { property: 'DC7EMISSAO' , label: 'Emissão'          , width: '7%'    , visible: true, type: 'date', format: 'dd/MM/yyyy' },
    { property: 'CCRNUM'     , label: 'Pedido'           , width: '6%'    , visible: true                                     },
    { property: 'CC7FORNECE' , label: 'Codigo'           , width: '6%'    , visible: true                                     },
    { property: 'CA2NREDUZ'  , label: 'Fornecedor'       , width: '11%'   , visible: true                                     },
    { property: 'CC7CC'      , label: 'Cod.CC'           , width: '130px' , visible: true                                     },
    { property: 'CCTTDESC01' , label: 'Centro Custo'     , width: '150PX' , visible: true                                     },
    { property: 'NCRTOTAL'   , label: 'Valor Pedido'     , width: '9%'    , visible: true, type: 'currency', format: 'BRL'    },
    { property: 'CCRNIVEL'   , label: 'Nivel'            , width: '5%'    , visible: true                                     },
    { property: 'NCRVALLIB'  , label: 'Valor Liberado'   , width: '8%'    , visible: true, type: 'currency', format: 'BRL'    },
    { property: 'DCRDATALIB' , label: 'Data Lib.'        , width: '7%'    , visible: true, type: 'date', format: 'dd/MM/yyyy' },
    { property: 'CCRUSERLIB' , label: 'Aprovador'        , width: '7%'    , visible: true                                     },
    { property: 'CCRUSER'    , label: 'Lista Aprovadores', width: '7%'    , visible: true                                     },
  ]

  public readonly tabelaDetalhesColunas: Array<PoTableColumn> = [
    {
      property: 'CCRSTATUS', label: 'Status', width: '10%', visible: true, type: 'label',
      labels: [
        { value: 'Aprovado',     label: 'Aprovado',       color: 'color-10' },
        { value: 'Pendente',     label: 'Pendente',       color: 'color-07' },
        { value: 'Pendente N.A.',label: 'Pend.Nivel Ant.',color: 'color-07' },
      ]
    },
    { property: 'DC7EMISSAO', label: 'Emissão'          , width: '9%'    , visible: true, type: 'date', format: 'dd/MM/yyyy' },
    { property: 'CCRNUM'    , label: 'Pedido'           , width: '7%'    , visible: true                                     },
    { property: 'CC7FORNECE', label: 'Codigo'           , width: '7%'    , visible: true                                     },
    { property: 'CA2NREDUZ' , label: 'Fornecedor'       , width: '12%'   , visible: true                                     },
    { property: 'CC7CC'     , label: 'Cod.CC'           , width: '110px' , visible: true                                     },
    { property: 'CCTTDESC01', label: 'Centro Custo'     , width: '150px' , visible: true                                     },
    { property: 'NCRTOTAL'  , label: 'Valor Pedido'     , width: '9%'    , visible: true, type: 'currency', format: 'BRL'    },
    { property: 'CCRNIVEL'  , label: 'Nivel'            , width: '5%'    , visible: true                                     },
    { property: 'NCRVALLIB' , label: 'Valor Liberado'   , width: '10%'   , visible: true, type: 'currency', format: 'BRL'    },
    { property: 'DCRDATALIB', label: 'Data Lib.'        , width: '9%'    , visible: true, type: 'date', format: 'dd/MM/yyyy' },
    { property: 'CCRUSERLIB', label: 'Aprovador'        , width: '9%'    , visible: true                                     },
    { property: 'CCROBS'    , label: 'Obs.'             , width: '5%'    , visible: false                                     },
    { property: 'CCRUSER'   , label: 'Lista Aprovadores', width: '9%'    , visible: true                                     },
  ]

  async loadAprovacoes(row: PedidoCompraPainelAprovacaoItem){
    const status = this.tabelaPrincipalFiltro.dados.CCRSTATUS
    this.tabelaPrincipalFiltro.dados.CCRNUM = row.CCRNUM
    this.tabelaPrincipalFiltro.dados.CCRSTATUS = ''
    this.pedidoCompraService.getPainelAprovacao(this.tabelaPrincipalFiltro.dados).subscribe(ret => {
      this.tabelaPrincipalDetalhes = ret.items
      this.tabelaPrincipalFiltro.dados.CCRNUM = '';
      this.tabelaPrincipalFiltro.dados.CCRSTATUS = status;
    });
  }

  advancedFilterActionModal():void{
    this.filtroAvancadoModal.open();
  }

  onChangeDisclaimer(disclaimers: Array<PoDisclaimerGroupComponent>): void {
    //@ts-ignore
    this.disclaimers = disclaimers;
  }

  public readonly filterSettings: PoPageFilter = {
    action: this.filterAction.bind(this),
    advancedAction: this.advancedFilterActionModal.bind(this),
    placeholder: 'Pesquisar'
  };

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.filtroAvancadoModal.close();;
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  }
  
  public filterAction(labelFilter: string | Array<string>): void{
    if (labelFilter){
      const filter = typeof labelFilter === 'string' ? [labelFilter] : [...labelFilter];
      this.populateDisclaimers(filter);
      this.filter();
    }
  }

  public populateDisclaimers(filters: Array<any>): void{
    //@ts-ignore
    this.disclaimers = filters.map((value)=> ({ value }));
    if (this.disclaimers && this.disclaimers.length > 0 ) {
      this.disclaimerGroup.disclaimers = [ ...this.disclaimerGroup.disclaimers, ...this.disclaimers];
    } else {
      this.disclaimerGroup.disclaimers = [];
    }
  }

  filter(): void {
    //@ts-ignore
    const filters = this.disclaimers.map((disclaimer)=> disclaimer.value);
    filters.length ? this.tabelaPrincipalFilter(filters) : this.resetFilterTabelaPrincipal();
  }

  tabelaPrincipalFilter(filters: any[]): any {
    this.resetFilterTabelaPrincipal();
    filters.forEach((filter)=> {
      this.tabelaPrincipalItensFiltrado = this.tabelaPrincipalItensFiltrado.filter((item)=>{
        //@ts-igonre
        return Object.keys(item).some(
           (key:string) => 
            //@ts-ignore
            !(item[key] instanceof Object) && this.includeFilter(item[key],filter))
      });
    });
  }

  includeFilter(item: any, filter: any): any{
    return String(item).toLocaleLowerCase().includes(filter.toLocaleLowerCase())
  }

  resetFilterTabelaPrincipal(): void{
    this.tabelaPrincipalItensFiltrado = [...this.tabelaPrincipalItens]
  }
}
